import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import axios from "axios";
import { utils } from "ethers";
import { CountryList} from "../components/CountryList";
import { useContractContext } from "../../hooks/useContractContext";

const Attestationpage = () => {
  const { copyrightsContract } = useContractContext();
  const [tokenId, setTokenId] = useState({ current: 0, new: "" });
  const [detailsOfWork, setDetailsOfWork] = useState({
    creatorPseudonym: "",
    typeOfWork: "",
    yearCreated: "",
    workIpfsCid: "",
  });
  const [creatorOfWork, setCreatorOfWork] = useState({
    fullName: "",
    country: "",
    uniqueIdentifier: "",
  });

  const [metaData, setMetaData] = useState();

  const [fullName, setFullName] = useState();
  const [natIdNum, setNatIdNum] = useState();
  const [country, setCountry] = useState();

  const [fullNameHash, setFullNameHash] = useState();
  const [countryHash, setCountryHash] = useState();
  const [uniqueIdHash, setUniqueIdHash] = useState();

  const [fullNameHashMatch, setFullNameHashMatch] = useState(false);
  const [countryHashMatch, setCountryHashMatch] = useState(false);
  const [uniqueIdHashMatch, setUniqueIdHashMatch] = useState(false);

  const fullNameChangeHandler = (event) => {
    const timeOutId = setTimeout(() => setFullName(event.target.value), 500);
    return () => clearTimeout(timeOutId);
  };
  const natIdNumChangeHandler = (event) => {
    const timeOutId = setTimeout(() => setNatIdNum(event.target.value), 500);
    return () => clearTimeout(timeOutId);
  };
  const countryChangeHandler = (event) => {
    const timeOutId = setTimeout(() => setCountry(event.target.value), 500);
    return () => clearTimeout(timeOutId);
  };
  const newTokenIdChangeHandler = (event) => {
    setTokenId({ ...tokenId, new: event.target.value });
  };

  const formatIpfsUrl = (url) => {
    return url.replace(/ipfs:\/\//g, "https://nftstorage.link/");
  };

  useEffect(() => {
    async function fetchData() {
      setDetailsOfWork(
        await copyrightsContract.checkDetailsOfWork(tokenId.current)
      );
      const ipfsUri = await copyrightsContract.tokenURI(tokenId.current);
      const formattedUri = formatIpfsUrl(ipfsUri);
      setMetaData((await axios.get(formattedUri)).data);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenId.current]);

  useEffect(() => {
    if (fullNameHash === creatorOfWork.fullName) {
      setFullNameHashMatch(true);
    } else if (fullNameHash !== creatorOfWork.fullName) {
      setFullNameHashMatch(false);
    }
    if (countryHash === creatorOfWork.country) {
      setCountryHashMatch(true);
    } else if (countryHash !== creatorOfWork.country) {
      setCountryHashMatch(false);
    }
    if (uniqueIdHash === creatorOfWork.uniqueIdentifier) {
      setUniqueIdHashMatch(true);
    } else if (uniqueIdHash !== creatorOfWork.uniqueIdentifier) {
      setUniqueIdHashMatch(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullNameHash, countryHash, uniqueIdHash]);

  const checkCreatorPrivateDetails = async () => {
    setCreatorOfWork(
      await copyrightsContract.checkCreatorOfWork(tokenId.current)
    );

    var fullNameBytes = utils.toUtf8Bytes(fullName.trim().toUpperCase());
    setFullNameHash(utils.sha256(fullNameBytes));

    var countryBytes = utils.toUtf8Bytes(country.trim().toUpperCase());
    setCountryHash(utils.sha256(countryBytes));

    var natIdNumBytes = utils.toUtf8Bytes(natIdNum.toUpperCase());
    setUniqueIdHash(utils.sha256(natIdNumBytes));
  };

  function updateTokenId(newTokenId) {
    setDetailsOfWork({
      creatorPseudonym: "",
      typeOfWork: "",
      yearCreated: "",
      workIpfsCid: "",
    });
    setMetaData(undefined);
    setTokenId({ current: newTokenId, new: "" });
  }

  return (
    <div>
      {/* {error && <ErrorModal title="title" message="message" />} */}
      <div>
        <section className="jumbotron breadcumb no-bg">
          <div className="mainbreadcumb">
            <div className="container">
              <div className="row m-10-hor">
                <div className="col-12">
                  <h1 className="text-center">Attestation</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6 col-xs-12">
              <h4>Work Details</h4>
              <div className="nft__item m-0">
                <div className="nft__item_wrap">
                  <span>
                    <img
                      src={formatIpfsUrl(detailsOfWork.workIpfsCid)}
                      id="get_file_2"
                      className="lazy nft__item_preview"
                      alt=""
                    />
                  </span>
                </div>
                <h4>Title of Work</h4>{" "}
                <span>
                  {metaData === undefined ? "loading..." : metaData.title}
                </span>
                <div className="spacer-10"></div>
                <h4>Description</h4>
                <span>
                  {metaData === undefined ? "loading..." : metaData.description}
                </span>
                <div className="spacer-10"></div>
                <h4>Year created</h4>
                <span>
                  {detailsOfWork.yearCreated === ""
                    ? "loading..."
                    : detailsOfWork.yearCreated}
                </span>
                <div className="spacer-10"></div>
                <h4>Type of Work</h4>
                <span>
                  {detailsOfWork.typeOfWork === ""
                    ? "loading..."
                    : detailsOfWork.typeOfWork}
                </span>
                <div className="spacer-10"></div>
                <h4>Creator Pseudonym</h4>
                <span>
                  {detailsOfWork.creatorPseudonym === ""
                    ? "loading..."
                    : detailsOfWork.creatorPseudonym}
                </span>
              </div>
              <div className="spacer-20"></div>
              <div className="nft__item m-0">
                <h4>TokenId</h4>
                <div>
                  <span>Current TokenId: {tokenId.current}</span>
                  <div className="spacer-10"></div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter tokenId"
                    onChange={newTokenIdChangeHandler}
                  />
                  <span
                    onClick={() => updateTokenId(tokenId.new.trim())}
                    className="btn-main lead"
                  >
                    Load New TokenId
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-7 offset-lg-1 mb-5">
              <form id="form-create-item" className="form-border" action="#">
                <div className="field-set">
                  <div className="spacer-10"></div>
                  <h4>Please input creator National Identifiers</h4>
                  <div className="spacer-10"></div>
                  <h5> Full Name (as per National ID)</h5>
                  <input
                    type="text"
                    name="creator_lastName"
                    id="creator_lastName"
                    className="form-control"
                    placeholder="e.g. 'Jane'"
                    onChange={fullNameChangeHandler}
                  />
                  <div className="spacer-10"></div>
                  <h5>National Identification Number</h5>
                  <input
                    type="text"
                    name="creator_uniqid"
                    id="creator_uniqid"
                    className="form-control"
                    placeholder="e.g. 'National Identity'"
                    onChange={natIdNumChangeHandler}
                  />

                  <h5>Country</h5>
                  <CountryList onChange={countryChangeHandler} />
                  <div className="spacer-10"></div>

                  <button
                    type="button"
                    id="submit"
                    className="btn-main"
                    onClick={checkCreatorPrivateDetails}
                  >
                    Verify
                  </button>

                  <div className="spacer-30"></div>
                  <h4>Full Name </h4>
                  <h6>{fullName}</h6>
                  <span>HASH (USER INPUT) : {fullNameHash}</span>
                  <br />
                  <span>HASH (BLOCKCHAIN) : {creatorOfWork.fullName}</span>
                  <div className="spacer-10"></div>
                  {fullNameHashMatch === true && (
                    <div className="alert-success">
                      HASH MATCH : VALIDATED{" "}
                      <i className="fa icon_box-checked" />{" "}
                    </div>
                  )}
                  {fullNameHashMatch === false && (
                    <div className="alert-warning">
                      WARNING : HASH VALUES DO NOT MATCH{" "}
                      <i className="fa fa-warning" />{" "}
                    </div>
                  )}

                  <div className="spacer-30"></div>
                  <h4>
                    Country
                    <h6>{country}</h6>
                  </h4>
                  <span>HASH (USER INPUT) : {countryHash}</span>
                  <br />
                  <span>HASH (BLOCKCHAIN) : {creatorOfWork.country}</span>
                  <div className="spacer-10"></div>
                  {countryHashMatch === true && (
                    <div className="alert-success">
                      HASH MATCH : VALIDATED{" "}
                      <i className="fa icon_box-checked" />{" "}
                    </div>
                  )}
                  {countryHashMatch === false && (
                    <div className="alert-warning">
                      WARNING : HASH VALUES DO NOT MATCH{" "}
                      <i className="fa fa-warning" />{" "}
                    </div>
                  )}

                  <div className="spacer-30" />
                  <h4>
                    Unique Identifier <h6>{natIdNum}</h6>
                  </h4>
                  <span>HASH (USER INPUT) : {uniqueIdHash}</span>
                  <br />
                  <span>
                    HASH (BLOCKCHAIN) : {creatorOfWork.uniqueIdentifier}
                  </span>
                  {uniqueIdHashMatch === true && (
                    <div className="alert-success">
                      HASH MATCH : VALIDATED{" "}
                      <i className="fa icon_box-checked" />{" "}
                    </div>
                  )}
                  {uniqueIdHashMatch === false && (
                    <div className="alert-warning">
                      WARNING : HASH VALUES DO NOT MATCH{" "}
                      <i className="fa fa-warning" />{" "}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Attestationpage;
